import { render } from "./Popover.vue?vue&type=template&id=04629e70&scoped=true"
import script from "./Popover.vue?vue&type=script&lang=js"
export * from "./Popover.vue?vue&type=script&lang=js"

import "./Popover.vue?vue&type=style&index=0&id=04629e70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04629e70"

export default script